@import "./sellalong-discount-display.css";

:host > * {
  font-family: var(--sellalong-control-font, sans-serif);
  font-size: 14px;
  letter-spacing: 2.6px;
  text-transform: uppercase;
  margin: 10px 0;
}

.sellalong-discount {
  padding: 0;
  margin-right: 4px;
  text-decoration-thickness: 2px;
}
